export const SERVICE_ID = 'service_uff625m';
export const TEMPLATE_ID = 'template_ccr1hqb';
export const USER_ID = '8OO7MFjG4TyC74TW8';